import {Component, OnInit} from '@angular/core';
import * as fromStore from "../store";
import {filter, first, switchMap} from "rxjs/operators";
import {UserSubscription, UserSubscriptionIds} from "../user/user-subscription";
import {Store} from "@ngrx/store";
import {ActivatedRoute} from "@angular/router";
import {UserService} from "../user/user.service";

@Component({
    selector: 'db-mobile-disclaimer',
    templateUrl: './mobile-disclaimer.component.html',
    styleUrls: ['./mobile-disclaimer.component.scss'],
    standalone: false
})
export class MobileDisclaimerComponent implements OnInit {

  public automatedSteps: string[];
  public userSubscription: UserSubscription;
  public userSubscriptionIds: any = UserSubscriptionIds;

  constructor(
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  ngOnInit(): void {
    const queryParams: any = (<any>this._route.queryParams).value;
    const sendMagicLink: boolean = !!queryParams.sendMagicLink;

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        if (userSubscription) {
          this.userSubscription = userSubscription;
          if (sendMagicLink && userSubscription && userSubscription.subscriptionId && [this.userSubscriptionIds.TRIAL].includes(userSubscription.subscriptionId)) {
            // this._userService.sendMagicLinkEmail(userSubscription.subscriptionId);
          }
            this.automatedSteps = ['Automated WordPress<br/>Hosting', 'One Click Automated<br/>Migration', 'Automated PageSpeed<br/>Optimization', 'Automated Website<br/>Creation Based on AI'];

        }

      });

  }

}
